import { useQuery } from '@apollo/client';
import { useAuth } from '@contexts/AuthContext';
import { SEARCH_JOB_OFFER_FILTERS } from '@gql/jobs';
import { isDateRange, isNumberRange } from '@components/Filter/filter.utils';
import { isArray, isObject } from 'lodash';
import { defaultJobOfferAvailableFilters, IJobOfferAvailableFilters, IJobOfferFilter } from '../JobOfferFilter';

export const useGetJobOfferAvailableFilters = (query: string, filter: IJobOfferFilter) => {
    const { user } = useAuth();

    const transformedFilter = Object.keys(filter).reduce((acc, key) => {
        const value = filter[key];
        if (key === 'jobApplicationStatus') {
            acc[key] = value.map(item => ({ status: item.group, subStatus: item.value }));
        } else if (key === 'specialties') {
            acc[key] = value?.map(item => item.value);
        } else if (isDateRange(value)) {
            acc[key] = { start: value?.start || null, end: value?.end || null };
        } else if (isNumberRange(value)) {
            if (value?.min && value?.max) {
                acc[key] = {
                    min: value?.min ? parseFloat(value?.min) : null,
                    max: value?.max ? parseFloat(value?.max) : null,
                };
            }
        } else if (isObject(value) && 'value' in value) {
            acc[key] = value.value;
        } else if (isArray(value)) {
            if (value && value?.length > 0) {
                acc[key] = value.map(item => (item?.value ? item.value : item));
            }
        } else {
            if (value) {
                acc[key] = value;
            }
        }
        return acc;
    }, {} as any);

    const { data, loading } = useQuery(SEARCH_JOB_OFFER_FILTERS, {
        variables: { query, filter: transformedFilter },
        fetchPolicy: 'cache-and-network',
        skip: !user,
    });

    return {
        availableFilters: (data?.searchJobOfferFilters as IJobOfferAvailableFilters) ?? defaultJobOfferAvailableFilters,
        loading,
    };
};
